import CryptoJS from 'crypto-js';

function getCryptoConfiguration() {
  const key = process.env.VUE_APP_CRYPTO_KEY;
  const hash = process.env.VUE_APP_CRYPTO_HASH;
  const iv = process.env.VUE_APP_CRYPTO_IV;

  if (!key || !hash || !iv)
    return null;

  return { key, hash, iv };
}

export function encrypte(data) {
  if (data) {
    const configuration = getCryptoConfiguration();
    if (!configuration)
      return `plain:${encodeURIComponent(data.toString())}`;

    const key = CryptoJS.PBKDF2(configuration.key, configuration.hash, { keySize: 256/32, iterations: 100 });
    const iv = CryptoJS.enc.Utf8.parse(configuration.iv);
    const encrypted = CryptoJS.AES.encrypt(data.toString(), key, { iv: iv, mode: CryptoJS.mode.CBC });
    return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
  }
}

export function decrypte(data) {
  if (data) {
    if (data.startsWith('plain:'))
      return decodeURIComponent(data.slice(6));

    const configuration = getCryptoConfiguration();
    if (!configuration)
      return null;

    const key = CryptoJS.PBKDF2(configuration.key, configuration.hash, { keySize: 256/32, iterations: 100 });
    const iv = CryptoJS.enc.Utf8.parse(configuration.iv);
    const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Hex.parse(data) }, key, { iv: iv, mode: CryptoJS.mode.CBC });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
